import React from 'react';
import styles from './PostMeta.module.css';
interface PostMetaProps {
    category: string;
    author: string;
    authorId: number;
    date: string;
}
const PostMeta: React.FC<PostMetaProps> = ({ category, author, authorId, date }) => {
    return (
        <div className={styles.meta}>
            <div className={styles.category}>{category}</div>
            <div className={styles.authorDate}>
                <span className={styles.author}>Автор: <a href={`/author/${authorId}`}>{author}</a></span>
                <time className={styles.date}>{date}</time>
            </div>
        </div>
    );
};
export default PostMeta;